import { Component, OnInit } from '@angular/core';
import { UserModel, ApplicationListModel } from '../../core/models/ShoppingCart.model';
import { HelperService } from '../../core/services/helper.service';
import { ShoppingService } from '../../core/services/shopping.service';
import { appVariables, Application, appMessages } from '../../core/constants/Common.constant';
import { environment } from '../../../environments/environment';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { OrdinalPipe } from '../../core/pipes/ordinal.pipes';
@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.css']
})
export class OrderDetailComponent implements OnInit {
  user = new UserModel();
  fromLocal: UserModel;
  ShippedProduct = [];
  DigitalProduct = [];
  ConfirmOrderObj: any;
  TotalShippedQuantity = 0;
  Token: string;
  loading = false;
  orderid = 0;
  OrderNumber = 0;
  ApplicationObj = new ApplicationListModel();
  ApplicationList = Array(new ApplicationListModel());
  APPID: string;
  AppUrl: string;
  ShowDiscount = false;
  ErroMessage = [];
  TrackingNumbers = [];
  UniqueTrackingNumbers = [];
  DiscountedPrice: number;
  DiscountedPriceArray = [];
  DiscountedPercent = [];
  UniqueDiscountedPercent: number;
  userDetails: UserModel;
  userFullName:string;
  userType: string;
  constructor(private helperService: HelperService, private shoppingService: ShoppingService,
    private titleService: Title, private activatedRoute: ActivatedRoute, private pipe: OrdinalPipe) {
    this.titleService.setTitle('Order Details | F.A. Davis');
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      const appID = params['appID'];
      const TokenID = params['token'];
      const GUID = params['GUID'];
      const promoCode = params['promoCode'];
      const OrderId = params['OrderId'];
      const isLTI = params['IsLTI'];
      this.shoppingService.SetDefaultOnLoad(appID, GUID, TokenID, promoCode, isLTI);
      this.shoppingService.IsCartComponent.emit(true);
      this.shoppingService.IsCheckoutComponent.emit(false);

      this.Token = this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage);
      if (this.Token) {
        this.shoppingService.IsLoggedIn.emit(true);
        this.shoppingService.setToken(this.Token);
        this.user.tokenFromUser = this.Token;
        this.shoppingService.logIn(this.user)
          .subscribe(
            (response) => {
              this.helperService.setUserToLocalStorage(response.Data);
              this.shoppingService.LoggedInDetails.emit(response.Data);
              this.fromLocal = this.helperService.getUserFromLocalStorage();
              this.shoppingService.setToken(this.fromLocal['token']);
              if (this.helperService.getFromLocalStorage(appVariables.displaySection) === '') {
                this.shoppingService.setDisplaySection('Login');
              }
              // document.getElementsByTagName('body')[0].appendChild(this.shoppingService.LoadScript(response));
            },
            (error) => { }
          );
      }
      this.GetOrderDetails(OrderId);
    });
    this.shoppingService.IsLoggedIn.emit(true);
    this.shoppingService.GetApplicationDetails();
    this.TotalShippedQuantity = 0;
    this.helperService.observeLoading.subscribe(loadingobj => {
      this.loading = loadingobj;
    });
    this.shoppingService.GetApplicationDetails();
    this.TotalShippedQuantity = 0;
    this.shoppingService.IsOrderDetailComponent.emit(true);
    this.ShowDiscount = false;
    this.shoppingService.LoggedInDetails.subscribe(data => {
      this.userDetails = data;
      this.userFullName=this.userDetails.FirstName +' '+ this.userDetails.LastName;
      this.userType = this.userDetails.Role;
    });
  }

  HandleError(error) {
    this.ErroMessage = [appMessages.CommonError]; // JSON.parse(error._body).Error;
  }
  GetOrderDetails(orderid) {
    this.shoppingService.GetOrderDetails(orderid)
      .subscribe(
        (response) => {
          this.ConfirmOrderObj = response;
          this.shoppingService.setOrderNumber(this.ConfirmOrderObj.Data.orderCalculation.ResponseHeader.WebOrderNo);
          response.Data.lstPurchasedProductAndSubproductsDetails.filter(obj => obj.Edition = this.pipe.transform(obj.Edition));
          this.ShippedProduct = response.Data.lstPurchasedProductAndSubproductsDetails.filter(obj =>
            obj.appid === 5);
          this.DigitalProduct = response.Data.lstPurchasedProductAndSubproductsDetails.filter(obj =>
            obj.appid !== 5);
          if (this.ConfirmOrderObj.Data.ListTrackingInfo && this.ConfirmOrderObj.Data.ListTrackingInfo.length > 0) {
            this.TrackingNumbers = this.ConfirmOrderObj.Data.ListTrackingInfo;
          }

          const TrackingNos = this.TrackingNumbers.map(e =>         
            {
          
               const trackingOrderInfo = {
                shippingLinks:e.ShippingLink,
                TrackingNo:e.TrackingNo
              }
              return trackingOrderInfo;
           
          });

          const trackingNosUnique = TrackingNos.filter(function (item, index) {
            return TrackingNos.indexOf(item) >= index;
          });
          

          this.UniqueTrackingNumbers = trackingNosUnique ;

          this.DiscountedPercent =  response.Data.lstPurchasedProductAndSubproductsDetails.map(item => item.discountPercentField);
          const DiscountedPercentArray = Array.from(new Set(this.DiscountedPercent));
          this.UniqueDiscountedPercent = DiscountedPercentArray[0];
console.log(response.Data.lstPurchasedProductAndSubproductsDetails);
          this.DiscountedPriceArray = response.Data.lstPurchasedProductAndSubproductsDetails
            .map(obj => obj.netPriceField - obj.listPriceField);

          this.DiscountedPrice = parseFloat(this.DiscountedPriceArray.reduce(this.getSum, 0).toFixed(2));
          if (this.UniqueDiscountedPercent > 0) {
            this.ShowDiscount = true;
          }
        },
        (error) => {
          this.HandleError(error);
        }
      );
  }
  setDefaultPic(cartitems) {
    cartitems.productImageUrl = environment.defaultProductImage; // 'assets/images/my-image.png';
  }

  setParentPic(cartitems) {
    // let isbn = '';
    this.shoppingService.GetParentProductImageFromAPI('1', cartitems.iSBNField)
      .subscribe(
        (response) => {
          cartitems.productImageUrl = response.Data;
        },
        (error) => {
          // .status === 401
          if (error) {
            this.HandleError(error);
          }
        }
      );
  }

  OnAccessNowClick(Url: string, appid) {
    if(appid==Application.DavisAdvantage.AppId) {
      let token = (this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage)) ? this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage) : ``;
      Url = (Url==null || Url=='') ? environment.SSOProducts : `${environment.davisadvantageLoginUrl}?token=${token}`;
    }
    window.open((Url==null || Url=='') ? environment.SSOProducts : Url, '_blank');

    // if (appid === 11 || appid === '11') {
    //   if (Url.slice(-1) === '/') {
    //     Url = Url.slice(0, -1);
    //   }
    //   window.open(Url + '?token=' + this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage), '_blank');
    // } else {
    //   window.open(Url, '_blank');
    // }
  }

  onTrackStatusClick() {
    window.open(environment.OrderSearchurl, '_blank');
  }

  onTrackingClick(ShippingLink: string) {
    window.open(ShippingLink, '_blank');
  }

  getSum(total, num) {
    return total + num;
  }
}




// WEBPACK FOOTER //
// ./src/app/shoppingcart/order-detail/order-detail.component.ts